import { Injectable } from '@nestjs/common';
import {CodeListDTO} from './dto/code-list.dto';
import {AllCodeListResponseModel, CodeListResponseModel} from '@gtpl/shared-models/planning';
import {CodeList} from './code-list.entity'
import {CodeListAdapter} from './dto/code-list.adapter';
import { Raw, Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CodeListRequest } from './dto/code-list.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class CodeListService {
  constructor(
    private logService:LogsService,

    @InjectRepository(CodeList)
    private codeListRepository: Repository<CodeList>,
    private codeListAdapter: CodeListAdapter,
  ){}
  async getCodeListDetailsWithoutRelations(traceabilityCode: string): Promise<CodeList> {
    
    // tslint:disable-next-line: typedef
    const codeListResponse = await this.codeListRepository.findOne({
      where: {traceabilityCode: Raw(alias => `traceability_code = '${traceabilityCode}'`)},
    });
    if (codeListResponse) {
      return codeListResponse;
    } else {
      return null;
    }
  }
  async createCodeList(codeListDTO: CodeListDTO, isUpdate: boolean): Promise<CodeListResponseModel> {
    // console.log(statesDto);
    try {
      // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      if (!isUpdate) {
        const codeListEntity = await this.getCodeListDetailsWithoutRelations(codeListDTO.traceabilityCode);
        if (codeListEntity) {
          //return new InformationMessageError(11104, "State already exists");
          throw new ErrorResponse(11104, 'Code List already exists');
        }
      }
      else{
        const codeListEntity = await this.getCodeListDetailsWithoutRelations(codeListDTO.traceabilityCode);
        if (codeListEntity) {
          if(codeListEntity.traceabilityCode!=codeListDTO.traceabilityCode) {
            throw new ErrorResponse(11104, 'Code List already exists');      
        }
          //return new InformationMessageError(11104, "State already exists");
        }
      }
      const codeList: CodeListDTO = this.codeListAdapter.convertDtoToEntity(codeListDTO,isUpdate);
      const savedCodeListEntity: CodeList = await this.codeListRepository.save(codeList);
      const savedCodeListDto: CodeListDTO = this.codeListAdapter.convertEntityToDto(codeList);
        // console.log(savedStateDto);
      if (savedCodeListDto) {
        // generating resposnse
        const response = new CodeListResponseModel(true,1,isUpdate? 'Resource efficiency updated Successfully': 'Resource efficiency Created Successfully',savedCodeListDto)
        const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'CodeListDTO', savedCodeListDto.codeListId, true, '',savedCodeListDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106,'Resource efficiency saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      throw error;
    }

  }
  async getAllCodeList(): Promise<AllCodeListResponseModel> {
    // const page: number = 1;
    
    try {
      const resourceOperationEfficiencyDtos: CodeListDTO[] = [];
      //retrieves all companies
      const resourceOperationEfficiencyEntities: CodeList[] = await this.codeListRepository.find();
      //console.log(statesEntities);
      if (resourceOperationEfficiencyEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        resourceOperationEfficiencyEntities.forEach(codeListEntity => {
          const convertedROEDto: CodeListDTO = this.codeListAdapter.convertEntityToDto(codeListEntity);
          resourceOperationEfficiencyDtos.push(convertedROEDto);
          // console.log('convertedCountriesDto');
          // console.log(convertedROEDto);
        });
       
        const response = new AllCodeListResponseModel(true,1,'Code list  retrieved successfully',resourceOperationEfficiencyDtos);
        //generated response
        const newLogDto = new LogsDto(1,'view', 'CodeListDTO', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    
    } catch (err) {
      throw err;
    }
  }
  async getAllActiveCodeList(): Promise<AllCodeListResponseModel> {
    // const page: number = 1;
    try {
        const countriesDto: CodeListDTO[] = [];
        //retrieves all companies
        const CountriesEntities: CodeList[] = await this.codeListRepository.find({where:{isActive:true},
       });
     console.log(CountriesEntities)
        if (CountriesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            CountriesEntities.forEach(countriesEntity => {
                const convertedcountriesDto: CodeListDTO = this.codeListAdapter.convertEntityToDto(
                  countriesEntity
                  
                );
                countriesDto.push(convertedcountriesDto);
            });
            const response = new AllCodeListResponseModel(true, 11108, "Data retrieved successfully",countriesDto);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found'); 
        }
    } catch (err) {
        throw err;
    }
  }

  /**
     * It deactivates value Code list 
     * @param CodeListRequest   type  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateProduct(codeListReq: CodeListRequest): Promise<CodeListResponseModel> {
      try {
        console.log(codeListReq);
        const codeListExists = await this.getCodeListById(codeListReq.codeListId);
        console.log(codeListExists);
          if (codeListExists) {
              if (codeListReq.versionFlag !== codeListExists.versionFlag) {
                  throw new ErrorResponse(10113, 'Someone updated the current code list information.Refresh and try again');
              } else {
                  
                      const codeListSatatus =  await this.codeListRepository.update(
                          { codeListId: codeListReq.codeListId },
                          { isActive: codeListReq.isActive,updatedUser: codeListReq.updatedUser });
                     
                      if (codeListExists.isActive) {
                          if (codeListSatatus.affected) {
                              const codeListResponse: CodeListResponseModel = new CodeListResponseModel(true, 10115, 'Code List is de-activated successfully');
                              return codeListResponse;
                          } else {
                              throw new ErrorResponse(10111, 'Code List is already deactivated');
                          }
                      } else {
                          if (codeListSatatus.affected) {
                              const codeListResponse: CodeListResponseModel = new CodeListResponseModel(true, 10114, 'Code List is activated successfully');
                              return codeListResponse;
                          } else {
                              throw new ErrorResponse(10112, 'Code List is already  activated');
                          }
                      }
                  // }
              }
          } else {
              throw new ErrorResponse(99998, 'No Records Found');
          }
      } catch (err) {
          throw err;
      }
  }

  async getCodeListById(codeListId: number): Promise<CodeList> {
        const Response = await this.codeListRepository.findOne({
        where: {codeListId: codeListId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }
}
